import { useState, type FormEvent } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { adminLogin, getAdminToken, setAdminToken } from '@/lib/api';
import '@/styles/admin.css';

export function AdminLoginPage() {
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (getAdminToken()) {
    return <Navigate to="/admin/stats" replace />;
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const token = await adminLogin(password);
      setAdminToken(token);
      nav('/admin/stats', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="admin-root">
      <div className="admin-shell">
        <div className="admin-form admin-card">
          <h1 className="admin-title">Estadísticas landing</h1>
          <p className="admin-subtitle">Acceso restringido — Interactive Talker</p>
          <form onSubmit={handleSubmit} style={{ marginTop: '1.5rem' }}>
            <label htmlFor="admin-password">Contraseña</label>
            <input
              id="admin-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {error ? <p className="admin-error">{error}</p> : null}
            <button type="submit" className="admin-btn admin-btn-primary" disabled={loading}>
              {loading ? 'Ingresando…' : 'Ingresar'}
            </button>
          </form>
          <p style={{ marginTop: '1.25rem', fontSize: '0.85rem' }}>
            <Link to="/" style={{ color: '#a5b4fc' }}>
              ← Volver al sitio
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
